import { cloneDeep } from 'lodash';

const getId = (id, entity) => `${entity}-${id}`;

const actions = {
  SET_TREE: ({ state, commit }, { entityId, entityType, tree }) => {
    const id = getId(entityId, entityType);
    commit('SET_TREE', { id, tree });
  },
  SET_OPEN: ({ state, commit }, { entityId, entityType, open }) => {
    const id = getId(entityId, entityType);
    commit('SET_OPEN', { id, open });
  },
};

const getters = {
  getTree: state => (entityId, entityType) => {
    const id = getId(entityId, entityType);
    return state.tree[id] || [];
  },
  getOpen: state => (entityId, entityType) => {
    const id = getId(entityId, entityType);
    return state.open[id] || [];
  },
};

const mutations = {
  SET_TREE(state, { id, tree }) {
    state.tree[id] = cloneDeep(tree);
  },
  SET_OPEN(state, { id, open }) {
    state.open[id] = cloneDeep(open);
  },
};

// I.E: {'section-212340' : [...], 'board-1235': [...]}
export default {
  namespaced: true,
  state() {
    return {
      tree: {},
      open: {},
    };
  },
  actions,
  getters,
  mutations,
};
